import { Fragment, Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router';
import Header from '@/components/Header/index';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/Sidebar/app-sidebar';
import { useLoadingGif } from '@/hooks/loadingGif.hook';
import { useAuth } from '@/hooks/auth.hook';
import { useSidebarByRole } from '@/services/sidebar.service';
import { useRootSelector } from '@/hooks/selector.hook';

// ─── MOCK CONFIG (REMOVE IN PRODUCTION) ──────────────────────────────────
const USE_MOCK_FALLBACK = false;
// ────────────────────────────────────────────────────────────────────────────

export default function MainLayout() {
  const LoadingGif = useLoadingGif();
  const { fetchProfile } = useAuth();
  const { getSidebarByRole } = useSidebarByRole();
  const { user, token } = useRootSelector((state) => state.auth);
  const { dataSidebar } = useRootSelector((state) => state.sidebar);

  // --- MOCK STATE (REMOVE IN PRODUCTION) ---
  const [forceRender, setForceRender] = useState(false);
  // -----------------------------------------

  useEffect(() => {
    if (token) {
      if (!user) {
        fetchProfile();
      }
      if (!dataSidebar?.navigation || dataSidebar.navigation.length === 0) {
        getSidebarByRole();
      }
    }
  }, [token, user, dataSidebar?.navigation?.length, fetchProfile, getSidebarByRole]);

  // --- MOCK FALLBACK (REMOVE IN PRODUCTION) ---
  useEffect(() => {
    if (!USE_MOCK_FALLBACK) return;
    const timer = setTimeout(() => setForceRender(true), 3000);
    return () => clearTimeout(timer);
  }, []);
  // --------------------------------------------

  // Check if user and sidebar data are loaded
  let isDataLoaded = Boolean(user && dataSidebar?.navigation && dataSidebar.navigation.length > 0);

  // --- MOCK OVERRIDE (REMOVE IN PRODUCTION) ---
  if (USE_MOCK_FALLBACK) {
    isDataLoaded = isDataLoaded || forceRender;
  }
  // --------------------------------------------

  return (
    <Fragment>
      <div className="min-h-screen bg-main overflow-x-hidden">
        <SidebarProvider>
          {/* Sidebar */}
          <div className="h-full">
            <AppSidebar />
          </div>

          {/* Main Content */}
          {isDataLoaded ? (
            <SidebarInset>
              <div className="transition-all duration-300 min-h-screen">
                {/* Header */}
                <Header />

                {/* Page Content */}
                <main className="px-[1rem] md:px-[3rem] pb-[2rem]">
                  <Suspense
                    fallback={
                      <div className="flex items-center justify-center h-screen">
                        <img src={LoadingGif} alt="Loading" className="w-[12rem] h-[12rem]" />
                      </div>
                    }
                  >
                    <Outlet />
                  </Suspense>
                </main>
              </div>
            </SidebarInset>
          ) : (
            <SidebarInset>
              <div className="flex items-center justify-center w-full h-screen bg-main">
                <img src={LoadingGif} alt="Loading" className="w-[8rem] h-[8rem] opacity-70" />
              </div>
            </SidebarInset>
          )}
        </SidebarProvider>
      </div>
    </Fragment>
  );
}
